"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DisconnectVideoConferencingParams () {
        return DisconnectVideoConferencingParams;
    },
    get GetUserCalendarsParams () {
        return GetUserCalendarsParams;
    },
    get GetUserVideoConferencingStatusQuery () {
        return GetUserVideoConferencingStatusQuery;
    },
    get InitiateCalendarIntegrationOAuthFlowParams () {
        return InitiateCalendarIntegrationOAuthFlowParams;
    },
    get InitiateVideoConferencingOAuthFlowParams () {
        return InitiateVideoConferencingOAuthFlowParams;
    },
    get OAuthCallbackParams () {
        return OAuthCallbackParams;
    },
    get PatchMeetingsIntegrationsSettingsRequest () {
        return PatchMeetingsIntegrationsSettingsRequest;
    },
    get SaveSelectedCalendarRequest () {
        return SaveSelectedCalendarRequest;
    },
    get VideoConferencingOAuthCallbackParams () {
        return VideoConferencingOAuthCallbackParams;
    }
});
const _zod = require("zod");
const _base = require("./base");
const PatchMeetingsIntegrationsSettingsRequest = _base.MeetingsIntegrationsSettingsSchema.refine((data)=>data.calendar !== undefined || data.video_conferencing !== undefined, {
    message: "At least one of `calendar` or `video_conferencing` must be provided"
});
const InitiateCalendarIntegrationOAuthFlowParams = _zod.z.object({
    provider: _zod.z.enum([
        "google",
        "outlook"
    ])
});
const SaveSelectedCalendarRequest = _zod.z.object({
    calendarId: _zod.z.string()
});
const GetUserCalendarsParams = _zod.z.object({
    provider: _zod.z.enum([
        "google",
        "outlook"
    ])
});
const OAuthCallbackParams = _zod.z.object({
    provider: _zod.z.enum([
        "google",
        "outlook"
    ])
});
const InitiateVideoConferencingOAuthFlowParams = _zod.z.object({
    provider: _base.VideoConferencingProviderEnum
});
const VideoConferencingOAuthCallbackParams = _zod.z.object({
    provider: _base.VideoConferencingProviderEnum
});
const DisconnectVideoConferencingParams = _zod.z.object({
    provider: _base.VideoConferencingProviderEnum
});
const GetUserVideoConferencingStatusQuery = _zod.z.object({
    includeUserSettings: _zod.z.enum([
        "true",
        "false"
    ]).transform((v)=>v === "true").optional()
});
